import { Button } from '@mui/material'
import { auth, provider } from '../firebase'
import { useStateValue } from '../StateProvider';
import { actionTypes } from '../reducer';
import "../styles/Login.css"

export default function Login() {
    const [{user}, dispatch] = useStateValue();


    const singIn = () =>{
        auth.signInWithPopup(provider)
        .then(result => {
            dispatch({
                type: actionTypes.SET_USER,
                user: result.user,
            })
        })
        .catch(error => alert(error.message));
    }

  return (
    <div className="login">
        <div className="login__container">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/768px-WhatsApp.svg.png?20220228223904" alt="" />
            <div className="login__text">
                <h1>Sing in to WhatsApp</h1>
            </div>
            
            <Button type='submit' onClick={singIn}>
                Sing In With Google
            </Button>
        </div>
    </div>
  )
}
